import AuthValidation from "../../validation/AuthValidation";
import { IRequestModel, HttpMethod, ValidationResponse } from "../../IRequestModel";

export class ChangePasswordRequest implements IRequestModel {

    constructor(oldPassword: string, newPassword: string) {
        this.old_password = oldPassword;
        this.new_password = newPassword;
    }

    uri: string = "auth/change-pass";
    method: HttpMethod = HttpMethod.POST;

    old_password: string;
    new_password: string;

    isValid(): ValidationResponse {
        let passOneValid: ValidationResponse = AuthValidation.PasswordValid(this.old_password, "Old Password");
        if (!passOneValid.isSuccess) {
            return passOneValid;
        }
        
        let passTwoValid: ValidationResponse = AuthValidation.PasswordValid(this.new_password, "New Password");
        return passTwoValid;
    }
}